<template>
    <div class="container">
        <div class="preloader" v-if="preloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
        <form class="feedback" @submit.prevent="sendForm()">
            <p class="title">Спасибо за проведенную презентацию!</p>
            <textarea 
                placeholder="Оставить комментарий по презентации"
                v-model="feedback.comment"
            ></textarea>
            <p class="title">Цели после презентации</p>
            
            <div class="input-group"  v-for="(field, index) in feedback.goal" :key="index">
                <input 
                    type="text" 
                    class="input-group__target"
                    :placeholder='"Цель" + (index + 1)'
                    v-model="field.name"
                >
            </div>
            <div class="addInput" @click="addTargetField()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-square-plus" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="rgba(196, 196, 196, 0.3)" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z"/>
                    <rect x="4" y="4" width="16" height="16" rx="2" />
                    <line x1="9" y1="12" x2="15" y2="12" />
                    <line x1="12" y1="9" x2="12" y2="15" />
                </svg>
            </div>
            <input :class="{blockedButton: blockButton}" type="submit" value="отправить">
            <p :class="{blockedButton: blockButton}" class="backToMain-btn backToCatalog" @click="goToMainPage()">заполнить позже</p>
        </form>
    </div>

</template>
<script>
import settings from '../settings'

export default {
    data: () => ({
        feedback: {
            goal: [
                {
                    id: 1,
                    name: '',
                    plan: ''
                }
            ],
            company: '',
            region: '',
            datePresentation: '',
            comment: '',
            collectionId: '',
            presentationId: ''
        },
        blockButton: false,
        preloader: false
    }),
    methods: {
        dateFormat(str){
            let arr = str.split('-');
            [arr[0], arr[2]] = [arr[2], arr[0]];
            return arr.join('.');
        },
        // Добавить поле с целью
        addTargetField(){
            let len = Object.keys(this.feedback.goal).length + 1;
            this.feedback.goal.push( {
                id: len,
                name: '',
                plan: ''
            })
        },
        clearPresenationInfo(){
            this.$store.dispatch('CLEAR_LOCAL_STORAGE');

            if(JSON.parse(localStorage.getItem('presentationStart'))){ 
                localStorage.removeItem('presentationStart');  //Удалить информацию о том, что проводится презентация
            }

            if(JSON.parse(localStorage.getItem('presentationStartedID'))){ 
                localStorage.removeItem('presentationStartedID');  //Удалить id коллекции по которой проводится презентация
            }

            if(JSON.parse(localStorage.getItem('presentationID'))){ 
                localStorage.removeItem('presentationID');  //Удалить Id текущей презентации
            }
        },

        // Отправить комментарий
        sendForm(){
            this.blockButton = true;
            this.preloader = true;
            let context = this;

            this.$axios({
                method: 'POST',
                url: settings.apiUrl + '/feedback/',
                data: JSON.stringify(this.feedback)
            }).then((response) => {
                this.$makeToast(
                    "Поздравляем!",
                    "success",
                    `Отзыв успешно сохранен! 
                    ID отзыва = ${response.data.data.id}`
                );

                context.preloader = true;

                let clientInfo = context.$localStorageGet('currentClientInfo');
                let data = {
                    clientId: clientInfo.client.id,
                    collectionId: context.feedback.collectionId,
                    presentationId: context.feedback.presentationId,
                    email: clientInfo.client.email
                }

                // Отправить отчет
                context.$store.dispatch('RE_SEND_REPORT', data);

            }).then((response) => {
                this.clearPresenationInfo();  //Очистить информацию о текущей презентации

                setTimeout(()=>{this.$router.push('/mainPage')}, 2000)
            });
        },

        // Заполнить отчет позднее
        goToMainPage(){
            this.clearPresenationInfo();  //Очистить информацию о текущей презентации
            this.$router.push('/mainPage')
        }

    },
    created(){
        let clientInfo = this.$localStorageGet('currentClientInfo');
        let presentationID = this.$localStorageGet('presentationID');

        this.feedback.company = clientInfo.client.name;
        this.feedback.region = clientInfo.client.region;
        // this.feedback.datePresentation = this.dateFormat(clientInfo.datePresentation);
        this.feedback.datePresentation = clientInfo.datePresentation;
        this.feedback.collectionId = clientInfo.collectionId;
        this.feedback.presentationId = presentationID;
    }
}
</script>
<style lang="scss" scoped>
    .shadow-block{
        // min-height: 100vh;
        // min-height: 600px;
        min-height: 100%;
        width: 100%;
    }
    .container{
        overflow: hidden;
        position: relative;
    }

    form, .responseLink{
        width: 100%;
        // min-height: 100vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;

        
        .title{
            font-size: 18px;
            line-height: 24px;
            display: flex;
            align-items: center;
            text-align: center;
            text-transform: uppercase;
            color: #fff;
            margin-bottom: 15px;
        }
        textarea{
            width: 100%;
            height: 175px;
            padding: 8px;
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            margin-bottom: 15px;
        }
        input[type='submit'],
        .backToCatalog{
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #000;
            font-size: 18px;
            text-transform: uppercase;
        }
    }
    .backToCatalog{
        margin-top: 20px;
    }
    .feedback{
        padding-top: 60px;
        height: 100%;
        flex-grow: 2;
    }
    .backToMain-btn{
        margin-top: 20px;
    }
    .signLink{
        right: -380px;
        position: absolute;
        top: 0;
        input[type='text']{
            width: 250px;
            margin-bottom: 38px;
            height: 20px;
            background: none;
            border: none;
            border-bottom: 1px solid #fff;
            padding: 5px 0px;
            color: #fff;
            font-size: 14px;
            line-height: 16px;
            outline: none;
            height: 40px;
            min-height: 40px;
        }
        input[type='submit']{
            width: 250px;
        }
        input.error{
            border: 1px solid red;
        }
    }
    .responseLink{
        padding: 15px;
        left: 0;
        position: absolute;
        display: none;
        opacity: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
            margin-bottom: 20px;
        }
        a{
            color: #000;
            height: 40px;
            margin-top: 50px;
            width: 250px;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            text-transform: uppercase;
        }
        #newLink{
            color: #fff;
            background: none;
            border: none;
            outline: none;
            word-break: break-all;
            &:hover{
                cursor: pointer;
            }
        }
    }
    .input-group{
        width: 250px;
        margin-bottom: 15px;

        input{
            width: 100%;
            height: 20px;
            font-size: 12px;
            background: none;
            border: none;
            outline: none;
            color: rgba(255, 255, 255, 0.5);
            
            &:hover,
            &:focus{
                border: none;
                outline: none;
                box-shadow: none;
                background: none;
            }
            &.input-group__target{
                border-bottom: 1px solid #fff;
            }
            &.input-group__plan{
                background: rgba(196, 196, 196, 0.3);
            }
        }
    }
    .addInput{
        margin-bottom: 20px;
        margin-bottom: auto;
    }
</style>